































































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { BButton, BFormInput } from 'bootstrap-vue';
import { Organisation, User } from '@/models/User';
import BaseCard from '@/components/BaseCard.vue';
import ModalUserPasswordForgot from '@/components/modals/UserPasswordForgot.vue';

@Component({
    name: 'Login',
    components: {
        'b-button': BButton,
        'b-form-input': BFormInput,
        'base-card': BaseCard,
        'modal-user-password-forgot': ModalUserPasswordForgot,
    },
    computed: mapGetters({
        account: 'account/account',
        organisation: 'organisation/organisation',
    }),
})
export default class Login extends Vue {
    error: string = '';
    loading: boolean = false;
    account!: User;
    organisation!: Organisation;
    email: string = '';
    password: string = '';
    updating: boolean = false;

    async login() {
        if (!this.email || !this.password) {
            return;
        }

        this.updating = true;

        try {
            const r = await this.$store.dispatch('account/login', {
                email: this.email,
                password: this.password,
            });

            if (r.response && r.response.data && r.response.data.code === 401) {
                throw Error(r.message);
            }

            localStorage.setItem('rbb:token', r.data.token);

            try {
                const account = await this.$store.dispatch('account/init');

                if (!account) {
                    return;
                } else {
                    await this.$store.dispatch('organisation/init', account);
                    const users = await this.$store.dispatch('users/init');
                    await this.$store.dispatch('formLabels/init');
                    await this.$store.dispatch('forms/init', users);
                }
            } catch (e) {
                this.error = e.toString();
            }

            this.$router.replace('/forms');
        } catch (e) {
            this.error = e.toString();
        } finally {
            this.updating = false;
        }
    }
}
